import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/users/$id')({
  component: UserDetailPage,
})

function UserDetailPage() {
  const { id } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="space-y-6">
            <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 pb-4">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                  User Profile
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mt-2">
                  View user information and activity
                </p>
              </div>
              <Link
                to="/users/$id/edit"
                params={{ id }}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Edit User
              </Link>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                User ID:
              </p>
              <code className="text-lg font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100">
                {id}
              </code>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                User Information (To be implemented)
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400">
                <li>User profile details (name, email, phone)</li>
                <li>Role and permissions</li>
                <li>Account status and verification</li>
                <li>Recent activity timeline</li>
                <li>Associated documents and signatures</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
